import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceStatusActions } from '@features/invoices/hooks/useInvoiceStatusActions'

import { useInvoice } from '../../../../contexts/invoiceContext'
import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'

export const MarkInvoiceAsSentButton = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoiceView } = useTrackInvoiceView()
  const { documentType, invoiceId } = useInvoice()

  const { markInvoiceAsSent, isProcessing } = useInvoiceStatusActions({ documentType, invoiceId })

  const handleMarkInvoiceAsSentButtonClick = useCallback(() => {
    trackInvoiceView('Mark as sent action clicked')
    markInvoiceAsSent()
  }, [markInvoiceAsSent, trackInvoiceView])

  return (
    <Button icon="paperPlane" loading={isProcessing} onClick={handleMarkInvoiceAsSentButtonClick} variant="outlined">
      {t('external_invoices.view.mark_as_sent')}
    </Button>
  )
}
